var _defs, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _rect2, _path10, _path11, _path12, _path13, _line, _path14, _rect3, _rect4, _text, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObj50Mvl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 731 356.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#50bd86;}.cls-2{fill:#434341;}.cls-3,.cls-7{fill:#fff;}.cls-4{fill:#ffdc00;}.cls-5{fill:#9164cd;}.cls-6{fill:#aae2c2;}.cls-7{font-size:35px;font-family:CloserText-Black, Closer Text;font-weight:800;letter-spacing:0.05em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.85,290.47a96.85,96.85,0,1,0-96.91-96.85A96.87,96.87,0,0,0,202.85,290.47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.85,292.38a98.77,98.77,0,1,1,98.82-98.76A98.91,98.91,0,0,1,202.85,292.38Zm0-193.7a94.94,94.94,0,1,0,95,94.94A95.07,95.07,0,0,0,202.85,98.68Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "309.63 114.36 285.07 112.71 283.05 87.78 318.33 52.5 320.16 77.24 344.91 79.08 309.63 114.36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310.36,116.32,283.3,114.5l-2.23-27.45L319.93,48.2l2,27.26,27.26,2Zm-23.52-5.41,22.05,1.48,31.72-31.72L318.38,79,316.73,56.8,285,88.51Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M202.85,270.27a76.66,76.66,0,1,0-76.71-76.65A76.68,76.68,0,0,0,202.85,270.27Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.85,247.05a53.43,53.43,0,1,0-53.46-53.43A53.45,53.45,0,0,0,202.85,247.05Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.85,249a55.34,55.34,0,1,1,55.37-55.34A55.42,55.42,0,0,1,202.85,249Zm0-106.86a51.52,51.52,0,1,0,51.55,51.52A51.59,51.59,0,0,0,202.85,142.1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.85,220.4a26.78,26.78,0,1,0-26.8-26.78A26.79,26.79,0,0,0,202.85,220.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.85,222.31a28.69,28.69,0,1,1,28.7-28.69A28.73,28.73,0,0,1,202.85,222.31Zm0-53.56a24.87,24.87,0,1,0,24.88,24.87A24.91,24.91,0,0,0,202.85,168.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 99.88,
    y: 118.29,
    width: 179.63,
    height: 35.67,
    rx: 4.85,
    transform: "translate(-23.17 40.2) rotate(-11.41)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110,172.19a8,8,0,0,1-4.46-1.36,8.07,8.07,0,0,1-3.46-5.13l-4.61-22.86a8.12,8.12,0,0,1,6.32-9.53l164-33.08a8.1,8.1,0,0,1,9.52,6.33l4.61,22.86a8.09,8.09,0,0,1-6.32,9.53L111.61,172A8.06,8.06,0,0,1,110,172.19Zm159.38-68.3a4,4,0,0,0-.84.09l-164,33.08a4.27,4.27,0,0,0-3.33,5L105.83,165a4.27,4.27,0,0,0,5,3.33l164-33.08a4.27,4.27,0,0,0,3.34-5l-4.61-22.87a4.31,4.31,0,0,0-4.18-3.42Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 101.87,
    y: 128.46,
    width: 175.9,
    height: 15.29,
    transform: "translate(-23.17 40.23) rotate(-11.41)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.31,64.65l-26,5.3a1,1,0,0,0-.86.85l-4.18,25.92a1,1,0,0,1-2,0L99.76,71.11a1,1,0,0,0-.83-.79L74.22,64.71a1,1,0,0,1-.07-2L98.51,58a1,1,0,0,0,.76-.75l6-24.64a1,1,0,0,1,2,0l4.88,24.19a1.05,1.05,0,0,0,.76.8l25.46,5A1,1,0,0,1,138.31,64.65Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M369.22,130.42l-20.08,4.09a.81.81,0,0,0-.66.66l-3.23,20a.79.79,0,0,1-1.56,0l-4.24-19.81a.78.78,0,0,0-.64-.61l-19.08-4.34a.79.79,0,0,1-.05-1.55l18.81-3.62a.78.78,0,0,0,.58-.58l4.66-19a.8.8,0,0,1,1.55,0L349,124.4a.8.8,0,0,0,.59.61l19.66,3.85A.8.8,0,0,1,369.22,130.42Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M357.59,279.39l-15.19,3.1a.59.59,0,0,0-.5.5l-2.44,15.14a.6.6,0,0,1-1.18,0l-3.21-15a.59.59,0,0,0-.48-.46l-14.44-3.28a.6.6,0,0,1,0-1.17l14.23-2.74a.61.61,0,0,0,.44-.44l3.53-14.4a.6.6,0,0,1,1.17,0l2.85,14.13a.6.6,0,0,0,.44.47l14.87,2.91A.6.6,0,0,1,357.59,279.39Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55.26,231.4l-18.12,3.7a.72.72,0,0,0-.6.59l-2.92,18.07a.71.71,0,0,1-1.4,0l-3.83-17.88a.71.71,0,0,0-.58-.56l-17.22-3.91a.72.72,0,0,1,0-1.4l17-3.26a.75.75,0,0,0,.53-.53l4.2-17.17a.72.72,0,0,1,1.4,0L37.05,226a.7.7,0,0,0,.53.55L55.32,230A.71.71,0,0,1,55.26,231.4Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 203.47,
    y1: 193.06,
    x2: 319.4,
    y2: 77.13
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.47,195a1.91,1.91,0,0,1-1.36-3.26L318.05,75.78a1.91,1.91,0,0,1,2.7,2.7L204.82,194.41A1.9,1.9,0,0,1,203.47,195Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 362.76,
    y: 191.36,
    width: 257,
    height: 34,
    rx: 17
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 371.76,
    y: 196.86,
    width: 134,
    height: 23,
    rx: 11.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(635.38 219.81)"
  }, "50%")), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M426.15,136.91a17.15,17.15,0,0,1,23.44,0,17.55,17.55,0,0,1,0,23.67,17.15,17.15,0,0,1-23.44,0,17.55,17.55,0,0,1,0-23.67ZM433,154.3a6.18,6.18,0,0,0,4.88,2.19,6.25,6.25,0,0,0,4.9-2.19,8.92,8.92,0,0,0,0-11.11,6.24,6.24,0,0,0-4.9-2.18,6.17,6.17,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M474.57,133a13.61,13.61,0,0,1,8.59,2.54,8,8,0,0,1,3.29,6.59,8.63,8.63,0,0,1-2.52,6.12,8.49,8.49,0,0,1,3.42,6.89,8.13,8.13,0,0,1-3.36,6.74,13.83,13.83,0,0,1-8.75,2.62h-16V133Zm-5.85,8v3.83h5.76a2.7,2.7,0,0,0,1.8-.57,1.71,1.71,0,0,0,.67-1.37,1.66,1.66,0,0,0-.67-1.35,2.8,2.8,0,0,0-1.8-.54Zm0,11.3v4.23h6.48a2.89,2.89,0,0,0,1.91-.59,2,2,0,0,0,.7-1.57,1.87,1.87,0,0,0-.72-1.47,2.86,2.86,0,0,0-1.89-.6Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M489.55,155.77a8.91,8.91,0,0,0,3.65.72q4.46,0,4.45-4.32V133h9.54v20.65a10.85,10.85,0,0,1-3.46,8.37,12.83,12.83,0,0,1-9.05,3.19q-3.74,0-5.13-1Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M513.09,133h24.3v8H522.58v3.74h12.74v7.74H522.58v4.05h15.26v8H513.09Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M560.52,141V164.5H551V141h-9.49v-8H570v8Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M574.47,133H584v31.5h-9.49Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M588.15,133H598.5l6.92,19.21,6.8-19.21h10.35l-12.92,31.5h-8.5Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M628.38,136.91a17.15,17.15,0,0,1,23.44,0,17.55,17.55,0,0,1,0,23.67,17.15,17.15,0,0,1-23.44,0,17.55,17.55,0,0,1,0-23.67Zm6.81,17.39a6.57,6.57,0,0,0,9.79,0,9,9,0,0,0,0-11.11,6.59,6.59,0,0,0-9.79,0,9,9,0,0,0,0,11.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObj50Mvl);
export default __webpack_public_path__ + "static/media/Obj_50-mvl.e67a1ca40c5c8d8df63174c4a920f8d9.svg";
export { ForwardRef as ReactComponent };